// extracted by mini-css-extract-plugin
export default {"row":"EditMapSize_row__2+6tV","sizeButton":"EditMapSize_sizeButton__pmZg7"};